// test421
(421 && 0);
